module.exports = __webpack_public_path__ + "static/img/3.c530b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-maquinaria-equipo-contratistas/3.png
// module id = zRg4
// module chunks = 0